<template>
  <div>
    <el-alert show-icon type="info1" title="Please Note" description="Any updated sites will only disappear on refresh." />
    <data-table
      ref="sitesWithoutLandowners"
      table-ref="sitesWithoutLandownersDataTable"

      title="Sites Without Landowners"
      icon="fa fa-user-slash"

      url="report/property/without/landlords"
      :fields="fields"

      detail-component="site-tenancy-detail-row"
      search-placeholder="Site Status, Site Names, Site Groups...">

      <template #show="scope">
        <el-button type="text" icon="fa fa-angle-double-down" @click="showSite(scope.rowData.id)">&nbsp;Show</el-button>
      </template>

    </data-table>
  </div>
</template>


<script>

import Vue from 'vue'

import DateMixins from '@/mixins/DateMixins'
import SiteTenancy from '@/components/sites/SiteTenancy'

Vue.component('site-tenancy-detail-row', SiteTenancy)

export default {

  mixins: [DateMixins],

  data () {
    return {

      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'site_id'
        },
        {
          title: 'Status',
          name: 'status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: !this.status || this.siteGroup
        },
        {
          title: 'Site Group',
          name: 'siteGroup',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          title: 'Site Name',
          name: 'siteName'
        },
        {
          title: 'Handover',
          name: 'handover',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          title: 'Tenancy Status',
          name: 'landStatus'
        },
        {
          title: 'Tenancy Type',
          name: 'landType'
        }
/*        ,
        {
          name: '__slot:show'
        }
*/
      ]
    }
  }
}
</script>
